import { Button, Form, Grid, Input, Tabs, TextArea, Toast } from "antd-mobile";
import React, { useEffect, useState } from "react";
import "./index.less";
import sdicHomeEmit from "@/utils/prototal";
import { isSdicHomeApp } from "@/utils/utils";
import { hardshipApply, hardshipApplyrRecords } from "@/api/hardship-aid";
import { API_RESULT_CODE } from "@/config/types/common";
import useSWR from "swr";
import { Helmet } from "react-helmet";

function HardshipAid() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [activeKey, setActiveKey] = useState("apply");

  const { data } = useSWR({ key: "hardshipApplyrRecords", activeKey }, async () => {
    if (activeKey === "record") {
      const { code, data, msg } = await hardshipApplyrRecords({ pageNum: 1, pageSize: 200 });
      if (code === API_RESULT_CODE.SUCCESS) {
        return data.list;
      }
      Toast.show(msg || "获取申请记录失败");
    }
    return [];
  });

  useEffect(() => {
    if (isSdicHomeApp()) {
      sdicHomeEmit("getUserInfo", {
        onCallback(data: any) {
          if (data) {
            try {
              const info = JSON.parse(data);
              form.setFieldsValue({
                ...info,
                realName: info.name,
                userId: info.username,
              });
            } catch (err) {
              console.error(err);
            }
          }
        },
      });
    }
  }, []);

  const onFinish = async () => {
    setLoading(true);
    const formData = await form.validateFields();

    const { code, msg } = await hardshipApply(formData);
    if (code === API_RESULT_CODE.SUCCESS) {
      Toast.show("申请成功");
    } else {
      Toast.show(msg);
    }
    setLoading(false);
  };

  return (
    <div className="hardship-aid">
      <Helmet title="困补申请"></Helmet>
      <Tabs activeKey={activeKey} onChange={setActiveKey}>
        <Tabs.Tab title="信息填报" key="apply">
          <Form
            form={form}
            layout="horizontal"
            footer={
              <Button block type="submit" color="primary" size="large" loading={loading}>
                提交
              </Button>
            }
            onFinish={onFinish}
          >
            <Form.Item
              name="realName"
              label="姓名"
              rules={[{ required: true, message: "姓名不能为空" }]}
            >
              <Input placeholder="请输入姓名" />
            </Form.Item>
            <Form.Item
              name="userId"
              label="员工号"
              rules={[{ required: true, message: "员工号不能为空" }]}
            >
              <Input placeholder="请输入员工号" />
            </Form.Item>
            <Form.Item name="gongHuiId" label="所属工会" hidden>
              <Input />
            </Form.Item>
            <Form.Item name="gongHuiName" label="所属工会">
              <Input readOnly />
            </Form.Item>
            <Form.Item
              name="phone"
              label="手机号"
              rules={[{ required: true, message: "手机号不能为空" }]}
            >
              <Input placeholder="请输入手机号" />
            </Form.Item>
            <Form.Item
              name="applyDesc"
              label="申请说明"
              rules={[{ required: true, message: "申请说明不能为空" }]}
            >
              <TextArea placeholder="请输入申请说明" maxLength={200} rows={4} showCount />
            </Form.Item>
          </Form>
        </Tabs.Tab>
        <Tabs.Tab title="申请记录" key="record">
          <Grid columns={3} gap={8} className="hardship-aid-table-row">
            <Grid.Item span={2}>
              <div className="hardship-aid-table-head">内容</div>
            </Grid.Item>
            <Grid.Item>
              <div className="hardship-aid-table-head">状态</div>
            </Grid.Item>
          </Grid>
          {data?.map((item, index) => (
            <Grid columns={3} gap={8} key={index} className="hardship-aid-table-row">
              <Grid.Item span={2}>
                <div className="hardship-aid-table-cell">{item.content}</div>
                {item.applyStatus === 2 && (
                  <div className="hardship-aid-table-tip">驳回原因：{item.rejectReason}</div>
                )}
              </Grid.Item>
              <Grid.Item>
                <div className="hardship-aid-table-cell">{item.applyStatusDesc}</div>
              </Grid.Item>
            </Grid>
          ))}
        </Tabs.Tab>
      </Tabs>
    </div>
  );
}

export default HardshipAid;
